var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('k-home-slideshow-hero'),_c('k-home-subtitle-hero'),_c('k-brand-current-batch-and-alumni'),_c('k-home-features'),_c('k-home-news')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }